import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

const calculateTotalFromCellByAlias = (alias: string, data: Array<ICell>) =>
  data.reduce((acc: number, { value, alias: cellAlias }) => (cellAlias === alias ? acc + Number(value) : acc), 0);

export default calculateTotalFromCellByAlias;
